var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderCancelledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h150v150H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.176 27.678c0-2.032 1.638-3.678 3.658-3.678H97.19c2.02 0 3.658 1.646 3.658 3.678 0 2.03-1.638 3.677-3.658 3.677H85.692c-2.02 0-3.659 1.647-3.659 3.678 0 2.031 1.638 3.678 3.659 3.678h26.655c2.598 0 4.704 2.117 4.704 4.728 0 2.612-2.106 4.728-4.704 4.728H30.291c-2.598 0-4.704-2.116-4.704-4.728 0-2.611 2.106-4.728 4.704-4.728h22.474c-.46 0-.901-.086-1.307-.242a3.679 3.679 0 0 0 2.352-3.436 3.678 3.678 0 0 0-2.352-3.436 3.636 3.636 0 0 1 1.307-.242h-9.93c-2.021 0-3.659-1.646-3.659-3.677ZM119.141 43.44c0-2.612 2.106-4.73 4.704-4.73h9.408c2.597 0 4.703 2.118 4.703 4.73 0 2.61-2.106 4.727-4.703 4.727h-9.408c-2.598 0-4.704-2.116-4.704-4.728ZM30.29 55.523c-2.597 0-4.703 2.117-4.703 4.728 0 2.612 2.106 4.729 4.704 4.729h64.286c2.597 0 4.704-2.117 4.704-4.729 0-2.611-2.107-4.728-4.704-4.728H30.29ZM5.726 76.275c0-2.176 1.755-3.94 3.92-3.94h31.882c2.165 0 3.92 1.764 3.92 3.94 0 2.177-1.755 3.94-3.92 3.94H39.96c-2.165 0-3.92 1.765-3.92 3.941s1.755 3.94 3.92 3.94h25.087c-2.165 0-3.92-1.764-3.92-3.94s1.755-3.94 3.92-3.94h59.059c2.165 0 3.92 1.764 3.92 3.94s-1.755 3.94-3.92 3.94h-10.714c-2.165 0-3.92 1.765-3.92 3.94 0 2.177 1.755 3.941 3.92 3.941h6.01c2.165 0 3.92 1.764 3.92 3.94 0 2.177-1.755 3.941-3.92 3.941H95.361c2.164 0 3.92 1.764 3.92 3.94s-1.756 3.941-3.92 3.941H64.524c-2.165 0-3.92 1.764-3.92 3.94s1.755 3.94 3.92 3.94h4.704c2.165 0 3.92 1.764 3.92 3.941 0 2.176-1.755 3.94-3.92 3.94H36.824c-2.165 0-3.92-1.764-3.92-3.94 0-2.177 1.755-3.941 3.92-3.941h.523c2.165 0 3.92-1.764 3.92-3.94s-1.755-3.94-3.92-3.94H4.42c-2.165 0-3.92-1.765-3.92-3.941s1.755-3.94 3.92-3.94H20.1c-2.166 0-3.92-1.764-3.92-3.94 0-2.177 1.754-3.94 3.92-3.94h.783c2.165 0 3.92-1.765 3.92-3.941s-1.755-3.94-3.92-3.94h-1.829c-2.165 0-3.92-1.765-3.92-3.94 0-2.177 1.755-3.941 3.92-3.941H9.646c-2.165 0-3.92-1.764-3.92-3.94ZM136.65 80.216c-2.165 0-3.92 1.764-3.92 3.94s1.755 3.94 3.92 3.94h9.93c2.165 0 3.92-1.764 3.92-3.94s-1.755-3.94-3.92-3.94h-9.93Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.009 113.315a3.144 3.144 0 0 0-3.136 3.152 3.144 3.144 0 0 0 3.136 3.152h6.794a3.144 3.144 0 0 0 3.136-3.152 3.144 3.144 0 0 0-3.136-3.152H93.01Z",
    fill: "#F6F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 98.438a3.938 3.938 0 1 0 0-7.876 3.938 3.938 0 0 0 0 7.876Zm0 1.312a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5ZM132.5 31.875a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25Zm0 1.875a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.541,
    cy: 65.041,
    r: 2.041,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.235,
    cy: 109.444,
    r: 2.041,
    fill: "#EEF2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.809 110.566a1.066 1.066 0 1 1 2.132 0v6.395a1.065 1.065 0 0 1-2.132 0v-6.395ZM128.809 122.289a1.065 1.065 0 0 1 2.132 0v6.395a1.066 1.066 0 1 1-2.132 0v-6.395ZM138.934 118.559a1.066 1.066 0 1 1 0 2.132h-6.395a1.065 1.065 0 0 1 0-2.132h6.395ZM127.211 118.559a1.065 1.065 0 0 1 0 2.132h-6.395a1.066 1.066 0 1 1 0-2.132h6.395ZM137.56 59.677a.51.51 0 0 1 .722.722l-2.165 2.164a.51.51 0 1 1-.721-.721l2.164-2.165ZM133.592 63.646a.51.51 0 1 1 .721.721l-2.164 2.165a.51.51 0 0 1-.722-.722l2.165-2.164ZM138.282 65.81a.51.51 0 0 1-.722.722l-2.164-2.165a.509.509 0 1 1 .721-.721l2.165 2.164ZM134.313 61.842a.509.509 0 1 1-.721.721l-2.165-2.164a.51.51 0 0 1 .722-.722l2.164 2.165ZM24.46 20.21a.79.79 0 0 1 0 1.58h-4.736a.79.79 0 0 1 0-1.58h4.736ZM15.776 20.21a.79.79 0 0 1 0 1.58H11.04a.79.79 0 0 1 0-1.58h4.736ZM18.54 27.71a.79.79 0 1 1-1.58 0v-4.736a.79.79 0 0 1 1.58 0v4.736ZM18.54 19.026a.79.79 0 0 1-1.58 0V14.29a.79.79 0 1 1 1.58 0v4.736Z",
    fill: "#D2D9E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.219 35.2a4.998 4.998 0 0 0-4.995-5.002H32.286A4.998 4.998 0 0 0 27.29 35.2v76.863c0 1.114.372 2.197 1.056 3.075l2.83 3.632c.5.641 1.468.641 1.968 0l3.886-4.988 3.885 4.988c.5.641 1.47.641 1.97 0l3.884-4.988 3.886 4.988c.5.641 1.469.641 1.969 0l3.885-4.988 3.75 4.942c.5.658 1.49.658 1.99 0l3.75-4.942 3.885 4.988c.5.641 1.47.641 1.97 0l3.885-4.988 3.885 4.988c.5.641 1.47.641 1.97 0l3.884-4.988 3.886 4.988c.5.641 1.469.641 1.969 0l2.829-3.632a5.003 5.003 0 0 0 1.056-3.075V35.199Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.336,
    y: 89.076,
    width: 41.25,
    height: 6,
    rx: 3,
    fill: "#fff",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.336,
    y: 69.576,
    width: 41.25,
    height: 5.25,
    rx: 2.625,
    fill: "#fff",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.336,
    y: 50.076,
    width: 41.25,
    height: 5.25,
    rx: 2.625,
    fill: "#fff",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.185,
    cy: 74.84,
    r: 28.34,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.07 61.888a2 2 0 0 0-2.828 0l-9.056 9.056-9.057-9.056a2 2 0 0 0-2.828 0l-1.068 1.068a2 2 0 0 0 0 2.828l9.056 9.056-9.056 9.057a2 2 0 0 0 0 2.828l1.068 1.068a2 2 0 0 0 2.828 0l9.057-9.056 9.056 9.056a2 2 0 0 0 2.829 0l1.067-1.068a2 2 0 0 0 0-2.828l-9.056-9.057 9.056-9.056a2 2 0 0 0 0-2.829l-1.068-1.067Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 61.403,
    y1: 122.45,
    x2: 88.357,
    y2: 21.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF1FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 66.845,
    y1: 50.279,
    x2: 123.525,
    y2: 111.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5535D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF979D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h150v150H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCancelledIcon);
export default __webpack_public_path__ + "static/media/order-cancelled-icon.588972262096694fa37cafdca9332486.svg";
export { ForwardRef as ReactComponent };